import React from 'react';
import Layout from '../components/Layout';
import { CumplimientoVentasVendedorComponent } from '../components/CumplimientoVentasVendedor/CumplimientoVentasVendedorComponent';

export default function CumplimientoVentasVendedor() {
  return (
    <div>
      <Layout />
      <div>
        <CumplimientoVentasVendedorComponent />
      </div>
    </div>
  );
}